import { createContext } from 'react';
import { TReferralData } from './ReferralProgramProvider';

export const ReferralProgramContext = createContext({
  isOpenModal: false,
  setIsOpenModalAction: (isOpen: boolean) => {},
  data: null as TReferralData | null,
  setDataAction: (data: TReferralData | null) => {},
});
